import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import api from '@appbase/api'
import { mapGetters, mapMutations } from 'vuex';
import * as appbaseTypes from '@appbase/store/types'
import * as types from '@home/store/types'
import localStorageHelper from '@appbase/util/local-storage-helper'
const EumCookiePrefix = ".EumDoNotPopup_"

@Component({
    components: {
    },
    computed: {
        ...mapGetters({
            isTeams: appbaseTypes.TEAMS,
            modalPopupItem: types.NOTICEPOPUP_MODAL_GET,
            modalPopupList: types.NOTICEPOPUP_MODAL_LIST_GET
        })
    } ,
    methods:{
        ...mapMutations({
            setTeams : appbaseTypes.TEAMS,
            setModalIdx: types.NOTICEPOPUP_MODAL_IDX_SET,
            setModalPopupItem: types.NOTICEPOPUP_MODAL_SET,
            setModalPopupList: types.NOTICEPOPUP_MODAL_LIST_SET,
        })
    }
})
export default class NoticePreviewView extends Vue {
    setTeams! : (value:boolean) => void
    setModalIdx! : (value:number) => void

    isTeams!: boolean
    

    popupItem?: noticepopup.NoticeItem | noticepopup.ModalNoticeItem
    modalPopupItem!: noticepopup.ModalNoticeItem
    isChecked: boolean = false

    modalPopupList!: noticepopup.ModalNoticeList
    totalPage:number = 1
    page:number = 1

    items: noticepopup.NoticeItem[] = []
    setModalPopupItem!: (data: noticepopup.ModalNoticeItem) => void
    setModalPopupList!: (data: noticepopup.ModalNoticeList) => void

    created() {
        // 테스트용 팀즈set
        //this.setTeams(true)

        if (this.isTeams == false) {

            let objData;

            if(this.$route.query.popupItem){
                const strData = <string>this.$route.query.popupItem
                const jsonData = decodeURIComponent(strData)
                objData = JSON.parse(jsonData)
            }
            if(this.$route.query){
                if(this.$route.query.htmlContent){
                    var obj = localStorageHelper.get(`$home/${this.$route.query.popupId}/htmlcontent`);
                    objData = JSON.parse(obj);
                }
            }
            if (objData) {
                //Created 라이프사이클에서는 ref 로 iframe 에 접근 할 수 없는 시점 데이터만 처리          
                this.popupItem = objData
            }
        } else { //팀즈인경우
            this.popupItem = this.modalPopupItem

            if (this.modalPopupList && Array.isArray(this.modalPopupList.items)) {
                if (this.modalPopupList.items.length > 0) {
                    this.popupItem = this.modalPopupList.items[0];
                    this.totalPage = this.modalPopupList.items.length;
                } 
            }  
            
        }

    }

    mounted() {
        this.initData()
    }

    initData(){
        //dom 그려지는 시점에서 데이터 입력
        if (this.popupItem) {
            //브라우저인경우만 타이틀 변경
            if(this.isTeams == false) window.document.title = this.popupItem.title

            let iframe = <HTMLIFrameElement>this.$refs.iframeRef;

            if (this.popupItem.noticePopupType == 1) {
                if (iframe.contentDocument) {
                    iframe.contentDocument.body.innerHTML = this.popupItem.noticePopupContents
                }
            } else {
               
                api.file.getFiles(this.popupItem.fileCode).then(result => {
                    let imgUrl = ""
                    if (result.length > 0) {
                        imgUrl = result[0].downloadUrl
                    } else {
                        // C:\NAS\gres\images\img_not_found.jpg
                        imgUrl = "/cm/gres/images/img_not_found.jpg"
                    }

                    if (iframe.contentDocument) {
                        iframe.contentDocument.body.innerHTML = `<img style='width:100%;height:100%' src='${imgUrl}' />`
                    }
                })
            }
        }
        //타이틀 변경

        // window.document.title = objData.title
        //     console.log(objData)

        //     //에디터 입력 데이터
        //     if(objData.noticePopupType == "1"){
        //         let iframe = this.$refs.iframeRef
        //         debugger
        //         // noticePopupContents
        //     }else{ //첨부 파일


        //     }
    }

    changeModalPage(){
        this.popupItem = this.modalPopupList.items[this.page-1]
        this.setModalIdx(this.page-1)
        this.initData();
    }

    close() {
        window.close()
    }

    // onClose(item: noticepopup.NoticeItem) {
    onClose() {
        var item: noticepopup.NoticeItem[] = [];

        if (!this.isChecked) {
            //modalPopupList.items[0]

            if (this.modalPopupList && Array.isArray(this.modalPopupList.items)) {
                if (this.modalPopupList.items.length > 0) {
                    var tempList: noticepopup.NoticeItem[] = [];
                    tempList.push(this.modalPopupList.items[0]);
                    this.setModalPopupList({modalShow:false, curIdx:0, items:tempList})
                }
            } else {
               //noticepopup = this.modalPopupItem
                item = [this.modalPopupItem]
                this.setModalPopupItem({...item[0] ,isShow:false})
            }
          
        }
        else {

            var noticePopupId: string = '';

            if (this.modalPopupList && Array.isArray(this.modalPopupList.items)) {
                if (this.modalPopupList.items.length > 0) {
                    item[0] = this.modalPopupList.items[0]
                }
            } else {
                item[0] = this.modalPopupItem
            }
            if (item[0]) {
                noticePopupId = `pop_n${item[0].noticePopupId}`;
            } else {
                noticePopupId = `pop_n${this.$route.query.popupId}`
            }
    
            // 일주일 동안 표시 안 함 처리
            if (this.isChecked === true) {
                let expires = new Date()
                let today = new Date();
                let date = today.getDate();
                expires.setDate(date + 7);
                // teams에서 Cookie set 안됨 > localstorage로 변경
                localStorage.setItem(`${noticePopupId}`,expires.toUTCString().toString()) 
            }
            if (this.isChecked && !this.items.length && !this.$route.query.itemId && this.isTeams) {
                if (this.modalPopupList && Array.isArray(this.modalPopupList.items)) {
                    if (this.modalPopupList.items.length > 0) {
                        var tempList: noticepopup.NoticeItem[] = [];
                        tempList.push(item[0]);
                        this.setModalPopupList({modalShow:false, curIdx:0, items:tempList})
                
                    }
                } else {
                    this.setModalPopupItem({...item[0] ,isShow:false})
                }
            }
        }
    }





    /**
     * 관리자 페이지에서는 대상아님
     */
    @Watch("isChecked")
    onChangedCheckedOption() {
        let expires = new Date()
        //체크된 상태 
        if (this.isChecked == true) {
            // 오늘 날짜 구해서 + 7 해서 넣어줌
            let today = new Date();
            let date = today.getDate();
            expires.setDate(date + 7);
        } else {
            expires.setHours(0, 0, 0, 0)
        }
        document.cookie = `${EumCookiePrefix}_${this.popupItem?.noticePopupId}=DONOTPOPUP;path=/; expires=${expires}`
    }

    @Watch('page')
    onChangeModalPage(val:number){
        if(val>0 && this.page > this.totalPage){
            this.page = 1
        }
        else if(val<0 && this.page == 0){
            this.page = this.modalPopupList.items.length
        }
        this.changeModalPage()
    }
}
